import axios from "axios";
import AuthContext from "./auth-context";
import { useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import {url} from './../constants'
export const reducerFunction = (state, action) => {
    switch(action.type) {
        case 'LOGIN_INITIALIZED':
            return { ...state, authLoading:action.payload ? false : true, userInfo:null}

        case 'LOGIN_SUCCESSFUL':
            localStorage.setItem('userInfo', JSON.stringify(action.payload))
            return {...state, authLoading:false, userInfo:action.payload, error:null}

        case 'LOGIN_FAILED':
            return {...state, authLoading:false, error:action.payload}

        case "REGISTER_INITIALIZED":
            return { ...state, registerLoading:true, userRegistered:null}
        
        case 'REGISTER_SUCCESSFUL':
            return { ...state, registerLoading:false, userRegistered:action.payload, error:null}
        
        case "REGISTER_FAILED":
            return { ...state, registerLoading:false, error:action.payload}
            
        case "GET_PRODUCTS_INIT":
            return { ...state, loading:true, products:null}
        
        case 'GET_PRODUCTS_SUCCESS':
            return { ...state, loading:false, products:action.payload, error:null}
        
        case "GET_PRODUCTS_FAILED":
            return { ...state, loading:false, error:action.payload}
        
        case "GET_YOUTUBE_INIT":
            return { ...state, loading:true, carouselData:null}
        
        case 'GET_YOUTUBE_SUCCESS':
            return { ...state, loading:false, carouselData:action.payload, error:null}
        
        case "GET_YOUTUBE_FAILED":
            return { ...state, loading:false, error:action.payload}

        case 'GET_ABOUT_ME_INIT':
            return { ...state, loading:true}  

        case 'GET_ABOUT_ME_SUCCESS':
            return { ...state, loading:false, aboutme:action.payload}  

        case 'GET_ABOUT_ME_FAILED':
            return { ...state, loading:false, error:action.payload}  
        
        case 'SUBMIT_FORM_INIT':
            return { ...state, loading:true}  
            
        case 'SUBMIT_FORM_SUCCESS':
            return { ...state, loading:false, formSubmitted:action.payload}  
            
        case 'SUBMIT_FORM_FAILED':
            return { ...state, loading:false, formError:action.payload}  

        case 'GET_CONTENT_REQUEST':
            return { ...state, loading:true}  

        case 'GET_CONTENT_SUCCESS':
            return { ...state, loading:false, content:action.payload}  

        case 'GET_CONTENT_FAILURE':
            return { ...state, loading:false, contentError:action.payload}  

        case 'EMAIL_SUBSCRIBE_REQUEST':
            return { ...state, loading:true, emailSuccess:false, emailError:false}  

        case 'EMAIL_SUBSCRIBE_SUCCESS':
            return { ...state, loading:false, emailSuccess:action.payload}  

        case 'EMAIL_SUBSCRIBE_FAILURE':
            return { ...state, loading:false, emailSuccess:false, emailError:action.payload}  

        default:
            return state
    }
}

const AuthState = (props) => {
    const initialState = {
        
    }
    const userInfo = localStorage.getItem('userInfo') ? JSON.stringify(localStorage.getItem('userInfo')) : null;
    const navigate = useNavigate()

    const [state, dispatch] = useReducer(reducerFunction, initialState)

    const login = async (data) => {
        try{
            dispatch({type:"LOGIN_INITIALIZED"})
            await axios({
                method:"POST",
                url:`${url}/api/loginUser/`,
                data:{'username':data.username, 'password':data.password},
                headers:{'Content-type':'application/json'}
            }).then(res => {
                dispatch({type:"LOGIN_SUCCESSFUL", payload:res.data})})
        }
        catch(error){
            dispatch({type:"LOGIN_FAILED", payload:error})
        }
        }

    const register = async (data) => {
        try{
            dispatch({type:"REGISTER_INITIALIZED"})
            await axios({
                method:"POST",
                url:`${url}/api/registerUser/`,
                data:{'username':data.username, 'fullName':data.fullName, 'password':data.password, 'email':data.email},
                headers:{'Content-Type':'application/json'}
            }).then(res => {
                dispatch({type:'REGISTER_SUCCESSFUL', payload:true })
            })
        }
        catch(error){
            dispatch({type:'REGISTER_FAILED', payload:error})
        }
    }

    const logout = () => {
        localStorage.removeItem('userInfo')
        dispatch({type:'LOGIN_INITIALIZED', payload:true})
        navigate('/Authentication')
    }

    const [products, setProducts] = useState([])
    const [banner, setBanner] = useState([])
    const getBanner = async () => {
        try{
            await axios.post(`${url}/api/getBanner/`).then(res => {
                setBanner(res.data)
            })
        }
        catch(error){
            dispatch({type:'GET_PRODUCTS_FAILED', payload:error})
        }
    }

    const getProducts = async () => {
        try{
            await axios.get(`${url}/api/getProducts/`).then(res => {
                setProducts(res.data)
            })
        }
        catch(error){
            dispatch({type:'GET_PRODUCTS_FAILED', payload:error})
        }

    }

    const getYoutubeVideoLinks = async () => {
        try{
            dispatch({type:'GET_YOUTUBE_INIT'})
            await axios.get(`${url}/api/getYtVideos/`).then(res => {
                dispatch({type:'GET_YOUTUBE_SUCCESS', payload:res.data})
            })
        }
        catch(error){
            dispatch({type:'GET_YOUTUBE_FAILED', payload:error})
        }

    }

    const getAboutMe = async () => {
        try{
            dispatch({type:'GET_ABOUT_ME_INIT'})
            await axios.get(`${url}/api/getAboutMe/`).then(res => {
                dispatch({type:'GET_ABOUT_ME_SUCCESS',payload:res.data})
            })
        }catch(error){
            dispatch({type:'GET_ABOUT_ME_FAILED', payload:error})
        }
    }

    const submitContactMeForm = async (data) => {
        try{
            dispatch({type:'SUBMIT_FORM_INIT'})
            await axios({
                url:`${url}/api/submitForm/`,
                method:'POST',
                data:data
            }).then(res => {
                dispatch({type:'SUBMIT_FORM_SUCCESS',payload:res.data})
            })
        }catch(error){
            dispatch({type:'SUBMIT_FORM_FAILED', payload:error})
        }
    }

    const getContent = async () => {
        try{
            dispatch({type:'GET_CONTENT_REQUEST'})
            const {data} = await axios.get(`${url}/api/getContent/`)
            dispatch({
                type:'GET_CONTENT_SUCCESS',
                payload:data
            })
        }catch(err){
            dispatch({
                type:'GET_CONTENT_FAILURE',
                payload:err
            })            
        }
    }

    const SubscribeToNewsLetter = async (email) => {
        try{
            dispatch({type:'EMAIL_SUBSCRIBE_REQUEST'})
            const {data} = await axios({
                url:`${url}/api/subscribeToEmail/`,
                method:"POST",
                data:{email:email}
            })
            dispatch({
                type:'EMAIL_SUBSCRIBE_SUCCESS',
                payload:data
            })
            setTimeout(()=>{
                dispatch({type:'EMAIL_SUBSCRIBE_REQUEST'}, 4000)
            })
        }catch(err){
            dispatch({
                type:'EMAIL_SUBSCRIBE_FAILURE',
                payload:err.response && err.response.data.details ? err.response.data.details : 'Something went wrong'
            })            
        }
    }
    return(
        <AuthContext.Provider value={{
            login,
            register,
            logout,
            getBanner,
            getProducts,
            getYoutubeVideoLinks,
            getAboutMe,
            submitContactMeForm,
            getContent,
            SubscribeToNewsLetter,
            state,
            products,
            banner,
            userInfo
        }}>
            {props.children}
        </AuthContext.Provider>
    )

}

export default AuthState;